import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';

import { OrganisationRoutingModule } from './organisation-routing.module';
import { OrganisationComponent } from './organisation.component';
import { OrganisationService } from './organisation.service';

import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { EducationModule } from '../education/education.module';
import { OrganisationsByEducationTypeAndOrganisationComponent } from './organisations-by-education-type-and-organisation/organisations-by-education-type-and-organisation.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    OrganisationComponent,
    OrganisationsByEducationTypeAndOrganisationComponent
  ],
  providers: [
    OrganisationService
  ],
  imports: [
    CommonModule,
    EducationModule,
    SharedModule,
    MaterialModule,
    OrganisationRoutingModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule
  ]
})
export class OrganisationModule { }
